<template>
  <section class="page-content">
    <article class="m-0 d-flex justify-content-center align-items-center title-section form-section">
      <h1 class="page-title">THANK YOU!</h1>
    </article>
    <article class="input-section form-section">
      <div>
        <p class="text-center">
          Your request to finance your policy has been submitted to OREP. An agent will send you a link to make your down payment and a Finance Agreement for your Signature within 1 business day. If you do not hear back from us within 1 business day, please email <a href="mailto:info@orep.org" target="_top">info@orep.org</a>
        </p>
      </div>
    </article>
  </section>
</template>

<script>
    export default {
        name: "individual-appraiser-email-sent"
    }
</script>

<style scoped>
  p {
    font-size: 18px;
  }
</style>

